import React from 'react';
import { useTranslation } from 'react-i18next';

export const SoftwareSection = ({ softwareSlides }) => {
  const { t } = useTranslation();

  return (
    <div class="vb-home-content-contrast vb-home-content-contrast--software">
      <div class="container vb-home-content">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="vb-about-subtitle-center">{t('home.software.title')}</h5>
          </div>
        </div>
        <div id="carouselExampleCaptions" class="carousel slide vb-home-carousel" data-bs-ride="carousel">
          <div class="carousel-indicators">
            {softwareSlides.map((softwareSlide, index) => (
              <button
                key={`software-indicator-${softwareSlide.id}`}
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to={index}
                class={index === 0 ? 'active' : ''}
                aria-current={index === 0 ? 'true' : undefined}
                aria-label={t('home.software.slideLabel', { index: index + 1, caption: softwareSlide.caption })}
              ></button>
            ))}
          </div>
          <div class="carousel-inner">
            {softwareSlides.map((softwareSlide, index) => (
              <div class={`carousel-item ${index === 0 ? 'active' : ''}`} key={`software-slide-${softwareSlide.id}`}>
                <img src={softwareSlide.image} class="vb-img-fit" alt={softwareSlide.alt} />
              </div>
            ))}
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{t('common.previous')}</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{t('common.next')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
